module.exports = __webpack_public_path__ + "static/media/04.5d40b322.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flight/volumetric/makeup/04.png
// module id = 637
// module chunks = 0